// Temporarily disabled for debugging
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Simple auth check without complex state management
  const user = useSupabaseUser();
  
  if (!user.value) {
    return navigateTo('/login');
  }
});